<!-- El disparador es un div[role=combobox] y NO un <button>: las fichas llevan
     su propio botón de quitar, y un <button> dentro de otro es HTML inválido —
     el parser cierra el externo y las fichas se salen de la caja. Es la regla
     R6 del linter. A cambio, el teclado se gestiona a mano. -->
<div class="dxc-combo__trigger dxc-combo__trigger--multi" role="combobox" tabindex="0"
  aria-haspopup="listbox" [attr.aria-expanded]="open" [attr.aria-label]="ariaLabel || null"
  [class.is-invalid]="invalid" (click)="onTriggerClick($event)" (keydown)="onKeydown($event)">
  <span class="dxc-combo__chips">
    @if (!value.length) {
      <span class="dxc-combo__value dxc-combo__value--placeholder">{{ placeholder }}</span>
    }
    @for (chip of visibleChips; track chip.value) {
      <span class="dxc-chip">
        <span>{{ chip.label }}</span>
        <button type="button" [attr.data-rm]="chip.value" [attr.aria-label]="'Quitar ' + chip.label">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
      </span>
    }
    @if (hiddenCount > 0) { <span class="dxc-chip dxc-chip--neutral">+{{ hiddenCount }}</span> }
  </span>
  <svg class="dxc-combo__chevron" width="14" height="14" aria-hidden="true" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
</div>

@if (open) {
  <ul class="dxc-combo__panel" role="listbox" aria-multiselectable="true"
    [class.dxc-combo__panel--up]="panelUp" [style]="panelStyle">
    @for (option of options; track option.value; let i = $index) {
      <li>
        <button type="button" class="dxc-combo__option" role="option" [disabled]="option.disabled"
          [attr.aria-selected]="isSelected(option.value)" [class.dxc-combo__option--active]="i === activeIndex"
          (mousedown)="$event.preventDefault()" (mouseenter)="activeIndex = i" (click)="toggleOption(option.value)">
          <span class="dxc-combo__box">
            @if (isSelected(option.value)) {
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m4 12 6 6L20 6"/></svg>
            }
          </span>
          <span class="dxc-combo__option-label">{{ option.label }}</span>
        </button>
      </li>
    }
    <li class="dxc-combo__foot">
      <span>{{ value.length }} de {{ options.length }} seleccionados</span>
      @if (clearable && value.length) {
        <button type="button" class="dxc-btn dxc-btn--link" (click)="clear()">Limpiar</button>
      }
    </li>
  </ul>
}
